import Highlight from "./Highlight"
import LineUp from "./LineUp"


function Home(){
    return(
        <>
            <Highlight/>
            <LineUp/>
        </>
    )
}

export default Home